import { Component, OnInit, Input } from '@angular/core';

import { FileUpload } from '@classes/file/file-upload';
import { UploadStatus } from '@enums/upload-status.enum';

@Component({
    selector: 'app-upload-progress',
    templateUrl: './upload-progress.component.html',
    styleUrls: ['./upload-progress.component.scss']
})
export class UploadProgressComponent implements OnInit {
    @Input() file: FileUpload;

    uploadStatus = UploadStatus;

    constructor() { }

    ngOnInit() {
    }

}
